/*
 * COCO HIT — Quick Wins pack v3.7
 * v3.7: Persistent MutationObserver on body — re-applies EOFY pricing when data-island re-renders cards
 * 2026-06-22: EOFY sale ended — isEofyActive() forced to false to remove the marquee, popup and sale pricing.
 */
(function () {
  var FREE_SHIP_THRESHOLD = 9900;
  var BRAND_ORANGE = '#F7941D';
  var DARK = '#1A1A1A';
  var EOFY_DISCOUNT = 0.20;
  var EOFY_EXCLUDED = ['best-seller-pack','founder-faves','matcha-moment','hydration-heroes','discovery-pack'];
  var EOFY_START = new Date('2026-06-16T00:00:00+10:00');
  var EOFY_END = new Date('2026-07-01T00:00:00+10:00');
  function isEofyActive() { return false; /* EOFY 2026 sale ended — promo display disabled */ }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function fmtAud(cents) { return '$' + (cents / 100).toFixed(2); }
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function injectMobileFixes() {
    if (document.getElementById('coco-mobile-fixes')) return;
    var style = document.createElement('style');
    style.id = 'coco-mobile-fixes';
    style.textContent = [
      '.ugc-carousel { overflow-y: hidden !important; overflow-x: auto !important; touch-action: pan-x !important; -webkit-overflow-scrolling: touch !important; }',
      '.ugc-carousel::-webkit-scrollbar { display: none; }',
      '.ugc-carousel { scrollbar-width: none; }',
      '.coco-stars-line { display: block !important; text-align: center !important; width: 100% !important; font-size: 18px !important; letter-spacing: 4px !important; line-height: 1 !important; margin-bottom: 8px !important; color: #F7941D !important; }',
      '.coco-heading-fixed h1, .coco-heading-fixed h2, .coco-heading-fixed h3, .coco-heading-fixed h4 { text-align: center !important; }',
      '.coco-eofy-price { line-height: 1.2; display: inline-block; }',
      '.coco-eofy-new { font-weight: 900; color: #F7941D; font-size: 1.1em; }',
      '.coco-eofy-old { text-decoration: line-through; color: #999; margin-left: 8px; font-size: 0.85em; }',
      '.coco-eofy-badge { display: inline-block; background: #F7941D; color: #FFFFFF; font-family: "Arial Black", Impact, sans-serif; font-weight: 900; font-size: 10px; padding: 3px 8px; border-radius: 50px; margin-left: 8px; letter-spacing: 1px; text-transform: uppercase; vertical-align: middle; }',
      '#coco-eofy-pdp-banner { background: linear-gradient(90deg, #F7941D 0%, #FFB347 100%); color: #1A1A1A; padding: 16px 18px; border-radius: 12px; margin: 14px 0; font-family: "Helvetica Neue", Arial, sans-serif; box-shadow: 0 2px 8px rgba(247, 148, 29, 0.25); }',
      '@media (max-width: 749px) {',
      '  body.template-index main > .shopify-section:first-of-type, body.template-index main > section:first-of-type { max-height: 55vh !important; max-height: 55svh !important; overflow: hidden !important; }',
      '  body.template-index main > .shopify-section:first-of-type img, body.template-index main > section:first-of-type img { max-height: 55vh !important; max-height: 55svh !important; height: auto !important; object-fit: cover !important; object-position: center !important; }',
      '  .coco-heading-fixed, .coco-heading-fixed section, .coco-heading-fixed .section-content { min-height: auto !important; height: auto !important; max-height: none !important; overflow: visible !important; padding-top: 12px !important; padding-bottom: 12px !important; }',
      '  .coco-heading-fixed h1, .coco-heading-fixed h2, .coco-heading-fixed h3 { font-size: 22px !important; line-height: 1.1 !important; margin: 0 !important; }',
      '  .coco-stars-line { font-size: 16px !important; letter-spacing: 3px !important; margin-bottom: 6px !important; }',
      '  body.template-index #coco-usp-strip { margin-bottom: 8px !important; padding-top: 14px !important; padding-bottom: 14px !important; }',
      '  #coco-usp-strip > div { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 12px 8px !important; justify-items: center !important; }',
      '  #coco-usp-strip > div > div { font-size: 10px !important; text-align: center !important; }',
      '  body.template-product [id*="discount"][class*="fixed"], body.template-product [class*="discount-popup"] { bottom: 80px !important; }',
      '  .coco-eofy-old { display: block; margin-left: 0; margin-top: 2px; }',
      '  .coco-eofy-badge { font-size: 9px; padding: 2px 6px; }',
      '}',
      '@media (max-width: 480px) {',
      '  body.template-index main > .shopify-section:first-of-type, body.template-index main > section:first-of-type { max-height: 50vh !important; max-height: 50svh !important; }',
      '  body.template-index main > .shopify-section:first-of-type img, body.template-index main > section:first-of-type img { max-height: 50vh !important; max-height: 50svh !important; }',
      '  .coco-heading-fixed h1, .coco-heading-fixed h2, .coco-heading-fixed h3 { font-size: 20px !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function injectEofyAnnouncement() {
    if (!isEofyActive()) return;
    if (document.getElementById('coco-eofy-banner')) return;
    var bar = document.createElement('div');
    bar.id = 'coco-eofy-banner';
    bar.style.cssText = 'background:linear-gradient(90deg,#F7941D 0%,#FFB347 50%,#F7941D 100%);color:#1A1A1A;font-family:"Arial Black",Impact,sans-serif;font-weight:900;font-size:13px;letter-spacing:1.8px;text-transform:uppercase;text-align:center;padding:10px 16px;position:relative;z-index:9990;overflow:hidden;';
    bar.innerHTML = '<div style="display:inline-block;white-space:nowrap;animation:cocoEofyMarquee 22s linear infinite;">✦ EOFY 20% OFF SITEWIDE • ENDS JUNE 30 • AUTO-APPLIED AT CHECKOUT ✦ EOFY 20% OFF SITEWIDE • ENDS JUNE 30 • AUTO-APPLIED AT CHECKOUT ✦ EOFY 20% OFF SITEWIDE • ENDS JUNE 30 • AUTO-APPLIED AT CHECKOUT</div>';
    var existingAnnouncement = document.querySelector('[id*="announcement-bar"]');
    if (existingAnnouncement) {
      existingAnnouncement.style.display = 'none';
      existingAnnouncement.parentNode.insertBefore(bar, existingAnnouncement);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
    var anim = document.createElement('style');
    anim.textContent = '@keyframes cocoEofyMarquee { 0% { transform: translateX(0); } 100% { transform: translateX(-33.33%); } }';
    document.head.appendChild(anim);
  }

  function showEofyPopup() {
    if (!isEofyActive()) return;
    if (document.getElementById('coco-eofy-popup')) return;
    try { if (localStorage.getItem('coco-eofy-dismissed') === '1') return; } catch (e) {}
    if (/\/cart|\/checkouts|\/account/.test(location.pathname)) return;
    setTimeout(function () {
      if (document.getElementById('coco-eofy-popup')) return;
      var overlay = document.createElement('div');
      overlay.id = 'coco-eofy-popup';
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(26,26,26,0.7);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;animation:cocoEofyFade 0.3s ease;';
      overlay.innerHTML = '<div style="background:#FFFFFF;border-radius:18px;max-width:440px;width:100%;padding:40px 32px 36px;text-align:center;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.4);animation:cocoEofyScale 0.4s cubic-bezier(0.34,1.56,0.64,1);font-family:Helvetica Neue,Arial,sans-serif;"><button id="coco-eofy-close" aria-label="Close" style="position:absolute;top:14px;right:14px;background:transparent;border:none;font-size:22px;cursor:pointer;color:#999;width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;">×</button><div style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:13px;color:#F7941D;letter-spacing:2.5px;text-transform:uppercase;margin-bottom:14px;">✦ EOFY 2026 ✦</div><div style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:42px;line-height:1;color:#1A1A1A;margin-bottom:8px;letter-spacing:-1.2px;">20% OFF</div><div style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:24px;line-height:1;color:#F7941D;margin-bottom:18px;letter-spacing:-0.5px;">SITEWIDE</div><div style="font-size:15px;color:#1A1A1A;line-height:1.5;margin-bottom:24px;">Auto-applied at checkout. No code needed.<br><strong>Ends June 30.</strong></div><a href="/collections/coconut-water-range" id="coco-eofy-cta" style="display:inline-block;background:#F7941D;color:#FFFFFF;font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:14px;letter-spacing:1.5px;text-transform:uppercase;padding:16px 36px;border-radius:50px;text-decoration:none;box-shadow:0 4px 0 #C76A0C;">Shop the range</a><div style="font-size:12px;color:#999;margin-top:18px;">Excludes bundles + subscriptions</div></div>';
      document.body.appendChild(overlay);
      var anim = document.createElement('style');
      anim.textContent = '@keyframes cocoEofyFade { from { opacity: 0; } to { opacity: 1; } } @keyframes cocoEofyScale { from { transform: scale(0.85); opacity: 0; } to { transform: scale(1); opacity: 1; } }';
      document.head.appendChild(anim);
      function dismiss() {
        try { localStorage.setItem('coco-eofy-dismissed', '1'); } catch (e) {}
        overlay.style.opacity = '0';
        setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
      }
      document.getElementById('coco-eofy-close').addEventListener('click', dismiss);
      document.getElementById('coco-eofy-cta').addEventListener('click', dismiss);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });
    }, 3500);
  }

  function parsePrice(text) {
    if (!text) return null;
    var m = text.replace(/,/g, '').match(/\$(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function getHandleFromAnchor(a) {
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function findCardPriceEl(card) {
    var priceEls = card.querySelectorAll('.price-item, [class*="price"], [class*="money"]');
    for (var i = 0; i < priceEls.length; i++) {
      var el = priceEls[i];
      // Skip if already our own injected element
      if (el.classList.contains('coco-eofy-price') || el.classList.contains('coco-eofy-new') || el.classList.contains('coco-eofy-old')) continue;
      // Skip if it CONTAINS our injected element (parent of replaced price)
      if (el.querySelector('.coco-eofy-price')) continue;
      if (parsePrice(el.textContent)) return el;
    }
    var leaves = card.querySelectorAll('span, div, p, strong, b');
    for (var k = 0; k < leaves.length; k++) {
      if (leaves[k].children.length !== 0) continue;
      if (leaves[k].closest('.coco-eofy-price')) continue;
      var txt = (leaves[k].textContent || '').trim();
      if (/^\$\d+(?:\.\d+)?(?:\s*AUD?)?\s*$/i.test(txt)) return leaves[k];
    }
    return null;
  }

  function injectEofyPricing() {
    if (!isEofyActive()) return;
    if (/\/collections\//.test(location.pathname) || location.pathname === '/' || location.pathname === '') {
      var anchors = document.querySelectorAll('a[href*="/products/"]');
      var processedCards = new WeakSet();
      anchors.forEach(function (a) {
        var handle = getHandleFromAnchor(a);
        if (!handle) return;
        if (EOFY_EXCLUDED.indexOf(handle) !== -1) return;
        var card = a.closest('li');
        if (!card) card = a.closest('.product-tile__container, .product-tile');
        if (!card) return;
        if (processedCards.has(card)) return;
        // Already has the EOFY badge from a previous run? Skip.
        if (card.querySelector('.coco-eofy-badge')) { processedCards.add(card); return; }
        var priceEl = findCardPriceEl(card);
        if (!priceEl) return;
        var original = parsePrice(priceEl.textContent);
        if (!original || original < 5) return;
        var discounted = (original * (1 - EOFY_DISCOUNT));
        processedCards.add(card);
        priceEl.innerHTML = '<span class="coco-eofy-price"><span class="coco-eofy-new">$' + discounted.toFixed(2) + '</span><span class="coco-eofy-old">$' + original.toFixed(2) + '</span><span class="coco-eofy-badge">EOFY -20%</span></span>';
      });
    }
    if (/\/products\//.test(location.pathname)) {
      var pdpHandle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
      if (EOFY_EXCLUDED.indexOf(pdpHandle) !== -1) return;
      if (document.getElementById('coco-eofy-pdp-banner')) return;
      var pdpPriceEl = $('.price-item--last') || $('.price-item') || $('[class*="price"]');
      if (!pdpPriceEl) return;
      var pdpOriginal = parsePrice(pdpPriceEl.textContent);
      if (!pdpOriginal || pdpOriginal < 5) return;
      var pdpDiscounted = pdpOriginal * (1 - EOFY_DISCOUNT);
      var pdpSaved = pdpOriginal - pdpDiscounted;
      var banner = document.createElement('div');
      banner.id = 'coco-eofy-pdp-banner';
      banner.innerHTML = '<div style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;color:#1A1A1A;margin-bottom:6px;">✦ EOFY 20% Off Auto-Applied at Checkout</div><div style="font-size:14px;color:#1A1A1A;line-height:1.5;">You pay <strong style="font-size:20px;font-weight:900;">$' + pdpDiscounted.toFixed(2) + '</strong> · You save <strong>$' + pdpSaved.toFixed(2) + '</strong></div>';
      pdpPriceEl.parentNode.insertBefore(banner, pdpPriceEl.nextSibling);
    }
  }

  // v3.7: Persistent MutationObserver — re-applies EOFY pricing when data-island re-renders the grid.
  // Debounced to avoid thrashing on rapid mutation bursts.
  var _eofyObserver = null;
  var _eofyDebounce = null;
  function setupEofyPriceObserver() {
    if (!isEofyActive()) return;
    if (_eofyObserver) return;
    // Wait for body to exist
    if (!document.body) return;
    _eofyObserver = new MutationObserver(function (mutations) {
      var hasRelevantChange = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            // Check if it's a product card or contains product anchors
            if (n.tagName === 'LI' || (n.querySelector && n.querySelector('a[href*="/products/"]'))) {
              hasRelevantChange = true; break;
            }
          }
        }
        if (hasRelevantChange) break;
      }
      if (!hasRelevantChange) return;
      if (_eofyDebounce) clearTimeout(_eofyDebounce);
      _eofyDebounce = setTimeout(function () { injectEofyPricing(); }, 100);
    });
    _eofyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function fixHeadingSections() {
    if (location.pathname !== '/' && location.pathname !== '') return;
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (s) {
      var headings = s.querySelectorAll('h1, h2, h3, h4');
      if (!headings.length) return;
      var sectionText = '';
      headings.forEach(function (h) { sectionText += ' ' + (h.textContent || ''); });
      var isHeadingOnly = /loved by thousands|coco lovers|hydration with|what our crew/i.test(sectionText);
      if (!isHeadingOnly) return;
      if (!s.classList.contains('coco-heading-fixed')) {
        s.classList.add('coco-heading-fixed');
        s.style.removeProperty('height'); s.style.removeProperty('min-height'); s.style.removeProperty('max-height'); s.style.removeProperty('overflow');
        s.querySelectorAll('section, .section-content').forEach(function (c) { c.style.removeProperty('height'); c.style.removeProperty('min-height'); c.style.removeProperty('max-height'); c.style.removeProperty('overflow'); });
      }
      headings.forEach(function (h) {
        if (h.dataset.cocoSplit) return;
        var raw = (h.textContent || '').trim();
        var m = raw.match(/^([★☆⋆\*]{2,})\s+(.+)$/);
        if (!m) return;
        h.dataset.cocoSplit = '1';
        h.innerHTML = '<span class="coco-stars-line">' + m[1] + '</span>' + m[2];
      });
    });
  }

  function setupUgcAutoScroll() {
    var carousels = document.querySelectorAll('.ugc-carousel');
    carousels.forEach(function (carousel) {
      if (carousel.dataset.cocoAutoScroll) return;
      if (carousel.scrollWidth <= carousel.clientWidth + 4) return;
      carousel.dataset.cocoAutoScroll = '1';
      var isMobile = window.innerWidth <= 768;
      var SPEED = isMobile ? 1.0 : 0.6;
      var PAUSE_MS = 3000;
      var paused = false;
      var resumeTimer = null;
      var scrollAccum = carousel.scrollLeft;
      function pause() { paused = true; if (resumeTimer) clearTimeout(resumeTimer); resumeTimer = setTimeout(function () { paused = false; }, PAUSE_MS); }
      carousel.addEventListener('mouseenter', function () { paused = true; if (resumeTimer) clearTimeout(resumeTimer); });
      carousel.addEventListener('mouseleave', function () { paused = false; });
      carousel.addEventListener('touchmove', pause, { passive: true });
      carousel.addEventListener('wheel', pause, { passive: true });
      var section = carousel.closest('section') || carousel.parentElement;
      if (section) { var arrows = section.querySelectorAll('button[class*="arrow"], button[class*="slider"], [class*="prev"], [class*="next"]'); arrows.forEach(function (a) { a.addEventListener('click', pause); }); }
      carousel.addEventListener('scroll', function () { if (paused) scrollAccum = carousel.scrollLeft; }, { passive: true });
      function tick() {
        if (!paused) { scrollAccum += SPEED; var maxScroll = carousel.scrollWidth - carousel.clientWidth; if (scrollAccum >= maxScroll - 1) { scrollAccum = 0; } carousel.scrollLeft = Math.round(scrollAccum); }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  function buildShippingBarEl(cart, contextId) {
    var total = cart.items_subtotal_price || cart.total_price || 0;
    var diff = Math.max(0, FREE_SHIP_THRESHOLD - total);
    var pct = Math.min(100, Math.round((total / FREE_SHIP_THRESHOLD) * 100));
    var unlocked = total >= FREE_SHIP_THRESHOLD;
    var bar = document.createElement('div');
    bar.id = contextId;
    bar.style.cssText = 'background:#FFF7EE;border:1px solid #F7E4C8;border-radius:12px;padding:14px 18px;margin:0 auto 16px;max-width:760px;font-family:Helvetica Neue,Arial,sans-serif;';
    var msg = unlocked ? '<strong style="color:' + BRAND_ORANGE + ';">🎉 You\'ve unlocked FREE shipping!</strong>' : 'You\'re <strong style="color:' + BRAND_ORANGE + ';">' + fmtAud(diff) + '</strong> away from <strong>FREE shipping</strong>';
    bar.innerHTML = '<div style="font-size:14px;color:' + DARK + ';text-align:center;margin-bottom:8px;">' + msg + '</div><div style="background:#EEE;border-radius:999px;height:8px;overflow:hidden;"><div style="background:' + BRAND_ORANGE + ';height:100%;width:' + pct + '%;transition:width 0.3s;"></div></div>';
    return bar;
  }
  function injectShippingBarOnCartPage() {
    if (!/\/cart/.test(location.pathname)) return;
    var existing = document.getElementById('coco-ship-bar'); if (existing) existing.remove();
    getCart().then(function (cart) { var bar = buildShippingBarEl(cart, 'coco-ship-bar'); var target = $('.cart, [data-cart-page], main'); if (target) target.insertBefore(bar, target.firstChild); }).catch(function () {});
  }
  function injectShippingBarInDrawer() {
    var drawer = document.getElementById('right-drawer-slot');
    if (!drawer || drawer.offsetWidth === 0) return;
    var cartForm = drawer.querySelector('#cart, form[action*="/cart"]');
    if (!cartForm) return;
    if (drawer.querySelector('#coco-ship-bar-drawer')) return;
    if (drawer.dataset.cocoShipPending === '1') return;
    drawer.dataset.cocoShipPending = '1';
    getCart().then(function (cart) {
      if (!drawer.querySelector('#coco-ship-bar-drawer')) {
        var bar = buildShippingBarEl(cart, 'coco-ship-bar-drawer');
        bar.style.margin = '12px 16px'; bar.style.maxWidth = 'none';
        var scrollArea = drawer.querySelector('[class*="overflow-y"], [class*="overflow-auto"]') || drawer.firstElementChild;
        if (scrollArea) scrollArea.insertBefore(bar, scrollArea.firstChild); else drawer.insertBefore(bar, drawer.firstChild);
      }
    }).catch(function () {}).then(function () { delete drawer.dataset.cocoShipPending; });
  }
  function watchDrawerForCart() {
    var modal = document.getElementById('modals-rightDrawer');
    if (!modal) {
      var bodyObs = new MutationObserver(function () { var m = document.getElementById('modals-rightDrawer'); if (m) { bodyObs.disconnect(); watchDrawerForCart(); } });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      return;
    }
    var obs = new MutationObserver(function () { injectShippingBarInDrawer(); });
    obs.observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }
  function buildStickyAtc() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.getElementById('coco-sticky-atc')) return;
    var priceEl = $('.price-item--last') || $('.price-item') || $('[class*="price"]');
    var titleEl = $('h1') || $('.product__title');
    if (!priceEl || !titleEl) return;
    var bar = document.createElement('div');
    bar.id = 'coco-sticky-atc';
    bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#FFFFFF;border-top:2px solid ' + BRAND_ORANGE + ';padding:10px 14px;display:none;align-items:center;justify-content:space-between;gap:12px;box-shadow:0 -4px 16px rgba(0,0,0,0.08);z-index:9998;font-family:Helvetica Neue,Arial,sans-serif;';
    bar.innerHTML = '<div style="flex:1;min-width:0;"><div style="font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:13px;text-transform:uppercase;color:' + DARK + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + (titleEl.textContent || '').trim() + '</div><div id="coco-sticky-price" style="font-size:14px;color:' + DARK + ';font-weight:700;">' + (priceEl.textContent || '').trim() + '</div></div><button id="coco-sticky-atc-btn" style="background:' + BRAND_ORANGE + ';color:#FFF;border:2px solid ' + DARK + ';font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:13px;letter-spacing:1.5px;text-transform:uppercase;padding:12px 18px;border-radius:999px;box-shadow:0 3px 0 ' + DARK + ';cursor:pointer;flex-shrink:0;">Add to cart</button>';
    document.body.appendChild(bar);
    var nativeAtc = $('.add-to-cart-btn') || $('button[name="add"]') || $('button[type="submit"]');
    bar.querySelector('#coco-sticky-atc-btn').addEventListener('click', function () { if (nativeAtc) nativeAtc.click(); });
    function syncVisibility() {
      var isMobile = window.innerWidth <= 768;
      if (!isMobile) { bar.style.display = 'none'; return; }
      var nativeRect = nativeAtc ? nativeAtc.getBoundingClientRect() : null;
      var shouldShow = nativeRect ? (nativeRect.bottom < 0 || nativeRect.top > window.innerHeight) : (window.scrollY > 400);
      bar.style.display = shouldShow ? 'flex' : 'none';
    }
    syncVisibility();
    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);
  }
  function buildUspStrip() {
    if (location.pathname !== '/' && location.pathname !== '') return;
    if (document.getElementById('coco-usp-strip')) return;
    var firstSection = $('main section');
    if (!firstSection) return;
    var strip = document.createElement('div');
    strip.id = 'coco-usp-strip';
    strip.style.cssText = 'background:#FFFFFF;padding:18px 16px;border-bottom:1px solid #EEE;font-family:Helvetica Neue,Arial,sans-serif;';
    strip.innerHTML = '<div style="max-width:1200px;margin:0 auto;display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;gap:8px;"><div style="display:flex;align-items:center;gap:8px;color:' + DARK + ';font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;"><span style="color:' + BRAND_ORANGE + ';font-size:18px;">✦</span> No added sugar</div><div style="display:flex;align-items:center;gap:8px;color:' + DARK + ';font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;"><span style="color:' + BRAND_ORANGE + ';font-size:18px;">✦</span> Vegan</div><div style="display:flex;align-items:center;gap:8px;color:' + DARK + ';font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;"><span style="color:' + BRAND_ORANGE + ';font-size:18px;">✦</span> 100% Natural</div><div style="display:flex;align-items:center;gap:8px;color:' + DARK + ';font-family:Arial Black,Impact,sans-serif;font-weight:900;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;"><span style="color:' + BRAND_ORANGE + ';font-size:18px;">✦</span> NOT YOUR AVERAGE</div></div>';
    firstSection.parentNode.insertBefore(strip, firstSection.nextSibling);
  }
  function injectReviewBadge() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.coco-review-badge-inline')) return;
    var title = $('h1');
    if (!title) return;
    var badge = document.createElement('div');
    badge.className = 'coco-review-badge-inline';
    badge.style.cssText = 'display:flex;align-items:center;gap:8px;margin:8px 0 14px;font-family:Helvetica Neue,Arial,sans-serif;font-size:14px;color:' + DARK + ';';
    badge.innerHTML = '<div class="jdgm-widget jdgm-preview-badge" data-template="product"></div>';
    title.parentNode.insertBefore(badge, title.nextSibling);
    if (window.jdgm && typeof window.jdgm.SETTINGS !== 'undefined' && typeof window.jdgm.processReviews === 'function') { try { window.jdgm.processReviews(); } catch (e) {} }
  }
  function applyNativeLazyLoad() {
    $$('img').forEach(function (img) { if (img.hasAttribute('loading')) return; var rect = img.getBoundingClientRect(); if (rect.top > window.innerHeight) { img.setAttribute('loading', 'lazy'); img.setAttribute('decoding', 'async'); } });
  }
  function injectBreadcrumbs() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.getElementById('coco-breadcrumbs')) return;
    var titleEl = $('h1');
    if (!titleEl) return;
    var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    var prodName = (titleEl.textContent || '').trim();
    var origin = location.origin;
    var crumbs = document.createElement('nav');
    crumbs.id = 'coco-breadcrumbs';
    crumbs.setAttribute('aria-label', 'Breadcrumb');
    crumbs.style.cssText = 'font-family:Helvetica Neue,Arial,sans-serif;font-size:13px;color:#666;padding:14px 24px 0;max-width:1820px;margin:0 auto;letter-spacing:0.3px;';
    crumbs.innerHTML = '<a href="/" style="color:#666;text-decoration:none;">Home</a> <span style="color:#CCC;margin:0 6px;">/</span> <a href="/collections/coconut-water-range" style="color:#666;text-decoration:none;">Coconut Water Range</a> <span style="color:#CCC;margin:0 6px;">/</span> <span style="color:' + DARK + ';font-weight:700;">' + prodName + '</span>';
    var main = $('#MainContent, main');
    if (main) main.insertBefore(crumbs, main.firstChild);
    var schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', 'itemListElement': [ { '@type': 'ListItem', position: 1, name: 'Home', item: origin + '/' }, { '@type': 'ListItem', position: 2, name: 'Coconut Water Range', item: origin + '/collections/coconut-water-range' }, { '@type': 'ListItem', position: 3, name: prodName, item: origin + '/products/' + handle } ] });
    document.head.appendChild(schema);
  }
  function init() {
    injectMobileFixes();
    injectEofyAnnouncement();
    injectShippingBarOnCartPage();
    buildStickyAtc();
    buildUspStrip();
    injectReviewBadge();
    injectBreadcrumbs();
    applyNativeLazyLoad();
    fixHeadingSections();
    setupUgcAutoScroll();
    injectEofyPricing();
    setupEofyPriceObserver();
    showEofyPopup();
  }
  function bootstrap() {
    init();
    watchDrawerForCart();
    var tries = 0;
    var iv = setInterval(function () { tries++; init(); if (tries > 10) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bootstrap); } else { bootstrap(); }
})();
